import { makeStyles, createStyles } from '@material-ui/core/styles'

export const useProfileFactoryCreateStyles = makeStyles((theme) =>
  createStyles({
    root: {
      margin: '0 -16px',

      [theme.breakpoints.up('sm')]: {
        margin: 'auto',
        width: 550
      }
    },

    buttonUpload: {
      display: 'block',
      textAlign: 'center'
    },

    wrapper: {
      boxShadow: '0 0 25px rgba(0, 0, 0, 0.1)',
      backgroundColor: '#fff',
      margin: '24px 0 32px 0',
      padding: 22,

      [theme.breakpoints.up('sm')]: {
        padding: 26,
        maxWidth: 550
      },

      [theme.breakpoints.up('md')]: {
        padding: 30
      },

      [theme.breakpoints.up('lg')]: {
        padding: 30
      }
    },

    title: {
      [theme.breakpoints.up('sm')]: {
        maxWidth: 550
      }
    },

    button: {
      marginLeft: 'auto',
      marginTop: 24
    },

    action: {
      display: 'flex'
    },

    tag: {
      marginRight: 12,
      marginBottom: 12
    },

    name: {
      marginBottom: 16
    },

    row: {
      marginBottom: 16
    },

    hideDragzone: {
      display: 'none'
    },

    text: {
      color: theme.palette.text.secondary,
      margin: 0,
      ...theme.typography.body2
    },

    icon: {
      color: theme.palette.text.secondary,
      width: 25,
      height: 25
    },

    dragzone: {
      minHeight: 'auto',
      padding: '12px 20px',
      margin: '20px 0'
    },

    item: {
      '& > img': {
        width: 56,
        height: 56,
        marginRight: 12
      },

      '& > p': {
        ...theme.typography.subtitle2
      }
    },

    grid: {
      marginBottom: 20
    }
  })
)
